var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "float-menu"
  }, [_c('div', {
    staticClass: "menu-item",
    on: {
      "click": _vm.handleMessage
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon/message.png"),
      "alt": "message"
    }
  })]), _c('div', {
    staticClass: "menu-item",
    on: {
      "mouseenter": e => _vm.updateInfoPosition('phone', e),
      "mouseleave": function ($event) {
        return _vm.startHideTimer('phone');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon/phone.png"),
      "alt": "phone"
    }
  })]), _c('div', {
    staticClass: "menu-item",
    on: {
      "mouseenter": e => _vm.updateInfoPosition('wechat', e),
      "mouseleave": function ($event) {
        return _vm.startHideTimer('wechat');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon/vxicon.png"),
      "alt": "wechat"
    }
  })]), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon/top.png"),
      "alt": "top"
    }
  })])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showPhoneInfo ? _c('div', {
    staticClass: "info-box phone-info-box",
    style: _vm.phoneInfoPosition
  }, [_c('span', {
    staticClass: "phone-number"
  }, [_vm._v("租赁热线：40000-33160")])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showWechatInfo ? _c('div', {
    staticClass: "info-box wechat-info-box",
    style: _vm.wechatInfoPosition
  }, [_c('div', {
    staticClass: "wechatInfo-box"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon/vx.png"),
      "width": "122",
      "height": "122",
      "alt": "QR Code"
    }
  }), _c('p', [_vm._v("添加我的企业微信")])])]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };